module.exports = CKEditor5.dll;